import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  jsonLd?: Record<string, any> | Record<string, any>[];
  ogImage?: string;
}

const BASE_URL = "https://aipalpiteguru.mentepoderosa2030.com";

const SEOHead = ({
  title,
  description,
  keywords,
  canonical,
  jsonLd,
  ogImage = `${BASE_URL}/pwa-512x512.png`,
}: SEOHeadProps) => {
  const fullTitle = title.includes("AI Palpite Guru") || title.includes("IA Palpite Guru")
    ? title
    : `${title} | IA Palpite Guru`;

  // Detect non-canonical hosts (Lovable preview/published domains)
  const isNonCanonicalHost =
    typeof window !== "undefined" &&
    (window.location.hostname.includes("lovable.app") ||
      window.location.hostname.includes("lovableproject.com"));

  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : undefined;
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  const robotsContent = isNonCanonicalHost
    ? "noindex, nofollow"
    : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
  const botsContent = isNonCanonicalHost ? "noindex, nofollow" : "index, follow";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Robots */}
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={botsContent} />
      <meta name="bingbot" content={botsContent} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="IA Palpite Guru — Palpites do Jogo do Bicho com Inteligência Artificial" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="IA Palpite Guru" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD (supports multiple) */}
      {jsonLdArray.map((schema, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEOHead;
